export default __webpack_public_path__ + "static/media/memora_2r3c.dc994eb7.png";